import script from "./notification-item.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-item.vue?vue&type=script&setup=true&lang=js"

import "./notification-item.vue?vue&type=style&index=0&id=26d073fe&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d073fe"]])

export default __exports__